import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogsReturnCode } from 'src/app/enums/dialogs/returnCode.enum';
import { HandlerManager } from 'src/app/managers/handler/handler.manager';
import { LoadingManager } from 'src/app/managers/loading/loading.manager';
import { SessionManager } from 'src/app/managers/session/session.manager';
import { User } from 'src/app/beans/login/user/user.bean';
import * as moment from 'moment';

@Component({
  selector: 'device.status.dialog',
  templateUrl: './device.status.dialog.html',
  styleUrls: ['./device.status.dialog.scss'],
})
export class DeviceStatusDialog implements OnInit, OnDestroy {
  list;
  siteId;
  lastRefresh;

  timeLeft: number = 60;
  interval;

  startTimer() {
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.getList();
      }
    }, 1000);
  }

  pauseTimer() {
    if (this.interval) clearInterval(this.interval);
  }

  mockup = [
    {
      deviceId: 1,
      type: 10,
      name: 'Codino 1',
      lastCheck: '2023-07-21 22:21:00',
      lastLog: '2023-07-21 14:10:16',
      logAction: 'T',
      logComment: 'Ticket AB123',
    },
    {
      deviceId: 2,
      type: 30,
      name: 'Summary 1',
      lastCheck: '2023-07-21 22:19:16',
      lastLog: '2023-07-21 14:10:16',
      logAction: 'T',
      logComment: 'Ticket AB123',
    },
    {
      deviceId: 1,
      type: 10,
      name: 'Codino 1',
      lastCheck: '2023-07-21 22:05:16',
      lastLog: '2023-07-21 14:10:16',
      logAction: 'T',
      logComment: 'Ticket AB123',
    },
    {
      deviceId: 2,
      type: 30,
      name: 'Summary 1',
      lastCheck: '2023-07-21 14:13:16',
      lastLog: '2023-07-21 14:10:16',
      logAction: 'T',
      logComment: 'Ticket AB123',
    },
  ];

  constructor(
    private dialogRef: MatDialogRef<DeviceStatusDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,

    private _handler: HandlerManager,
    private _loader: LoadingManager,
    private _session: SessionManager
  ) {}

  ngOnInit(): void {
    const user = this._session.user().get();
    this.init();
  }

  ngOnDestroy(): void {
    this.pauseTimer();
  }

  async init() {
    this.siteId = this.data.siteId;
    this.getList();
  }

  //---------------------------------------------------------------------------------------------------

  async getList() {
    this.pauseTimer();
    this.timeLeft = 60;
    this.startTimer();
    this.lastRefresh = moment().format('YYYY-MM-DD HH:mm:ss');
    // this.list = [];
    const user = this._session.user().get();

    if (!User.isKind(user)) return; // TODO handle user incorrect

    let response;

    this._loader.start();

    this.list = await this._handler.deviceStatus().get(this.siteId);

    this._loader.stop();

    // if (!response) return;

    // this.list = (response as any).list;
  }

  checkStatus(lastCheck) {
    let color = 'red';
    if (lastCheck) {
      const diff = moment(this.lastRefresh).diff(moment(lastCheck), 'minutes');
      if (diff < 20) {
        color = 'orange';
      }
      if (diff < 10) {
        color = 'yellow';
      }
      if (diff < 2) {
        color = 'green';
      }
    }

    return color;
  }

  refresh() {
    this.getList();
  }

  cancel() {
    this.pauseTimer();
    this.dialogRef.close({
      code: DialogsReturnCode.OPERATION_DECLINED,
    });
  }

  //---------------------------------------------------------------------------------------------------

  //---------------------------------------------------------------------------------------------------
}
